"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const enrolment_1 = require("../../helpers/enrolment");
// import getEnrolmentOfContent from '../../helpers/enrolment/getEnrolmentOfContent';
const getIndexOfEnrolmentOfContent_1 = tslib_1.__importDefault(require("../../helpers/enrolment/getIndexOfEnrolmentOfContent"));
const updateEnrolmentFields_1 = require("../../helpers/enrolment/updateEnrolmentFields");
function updateEnrolments(enrolments, command, content, user) {
    const enrolmentIndex = getIndexOfEnrolmentOfContent_1.default(enrolments, content._id, command.userId);
    let updatedEnrolments = immer_1.default(enrolments, (draftEnrolments) => {
        const enrolmentInst = draftEnrolments[enrolmentIndex];
        const enrolment = enrolment_1.createOrUpdateEnrolment(command, content, enrolmentInst, user);
        if (enrolmentIndex === -1) {
            draftEnrolments.push(enrolment);
        }
        else {
            draftEnrolments[enrolmentIndex] = enrolment;
        }
    });
    if (enrolments[enrolmentIndex] !== updatedEnrolments[enrolmentIndex]) {
        updatedEnrolments = immer_1.default(updatedEnrolments, (draftEnrolments) => {
            const enrolment = draftEnrolments[enrolmentIndex];
            updateEnrolmentFields_1.updateDates(command, enrolment);
        });
    }
    return updatedEnrolments;
}
exports.default = updateEnrolments;
//# sourceMappingURL=updateEnrolments.js.map